import { render } from "./DepotInventory.vue?vue&type=template&id=68ee0ee8"
import script from "./DepotInventory.vue?vue&type=script&lang=js"
export * from "./DepotInventory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__